// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiiif-share-button-group {
    display: flex;
    margin-bottom: 16px;
    flex-wrap: wrap;
}

.aiiif-share-button-group > a {
    background-color: #5a5858;
    border-radius: 32px;
    height: 52px;
    width: 52px;
    display: flex;
    margin: 0 16px 16px 0;
    cursor: pointer;
    font-size: 1.6rem;
    align-items: center;
    justify-content: center;
    color: white;
}

.aiiif-share-button-group > a.aiiif-share-button svg {
    margin: auto;
    color: white;
}

.aiiif-share-button-group > a.aiiif-share-button-email {
    background-color: #888888;
}

.aiiif-share-button-group > a.aiiif-share-button-facebook {
    background-color: #3b5998;
}

.aiiif-share-button-group > a.aiiif-share-button-facebook svg {
    color: white;
}

.aiiif-share-button-group > a.aiiif-share-button-twitter {
    background-color: #1da1f2;
}

.aiiif-share-button-group > a.aiiif-share-button-twitter svg {
    height: inherit;
    color: white;
}

.aiiif-share-button-group > a.aiiif-share-button-iiif {
    background-color: ghostwhite;
}

.aiiif-share-button-group > a.aiiif-share-button-iiif svg {
    width: 60%;
    height: 60%;
}

.aiiif-share-code {
    font-family: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
    background-color: #fafafa;
    border-radius: 3px;
    border: 1px solid rgb(237, 237, 237);
    display: block;
    padding: 12px;
    margin: 24px 0 12px;
}
`, "",{"version":3,"sources":["webpack://./src/infoBar/tabs/share.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,2FAA2F;IAC3F,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".aiiif-share-button-group {\n    display: flex;\n    margin-bottom: 16px;\n    flex-wrap: wrap;\n}\n\n.aiiif-share-button-group > a {\n    background-color: #5a5858;\n    border-radius: 32px;\n    height: 52px;\n    width: 52px;\n    display: flex;\n    margin: 0 16px 16px 0;\n    cursor: pointer;\n    font-size: 1.6rem;\n    align-items: center;\n    justify-content: center;\n    color: white;\n}\n\n.aiiif-share-button-group > a.aiiif-share-button svg {\n    margin: auto;\n    color: white;\n}\n\n.aiiif-share-button-group > a.aiiif-share-button-email {\n    background-color: #888888;\n}\n\n.aiiif-share-button-group > a.aiiif-share-button-facebook {\n    background-color: #3b5998;\n}\n\n.aiiif-share-button-group > a.aiiif-share-button-facebook svg {\n    color: white;\n}\n\n.aiiif-share-button-group > a.aiiif-share-button-twitter {\n    background-color: #1da1f2;\n}\n\n.aiiif-share-button-group > a.aiiif-share-button-twitter svg {\n    height: inherit;\n    color: white;\n}\n\n.aiiif-share-button-group > a.aiiif-share-button-iiif {\n    background-color: ghostwhite;\n}\n\n.aiiif-share-button-group > a.aiiif-share-button-iiif svg {\n    width: 60%;\n    height: 60%;\n}\n\n.aiiif-share-code {\n    font-family: SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;\n    background-color: #fafafa;\n    border-radius: 3px;\n    border: 1px solid rgb(237, 237, 237);\n    display: block;\n    padding: 12px;\n    margin: 24px 0 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
